export default __webpack_public_path__ + "static/media/online-dot.44639b4e.png";